import Vue from 'vue'
import Vuex from 'vuex'
import Quotes from './modules/Quotes'
import Customers from './modules/Customers'
import Categories from './modules/Categories'
import Items from './modules/Items'
Vue.use(Vuex)
export default new Vuex.Store({  
  modules: {
    Quotes,
    Categories,
    Customers,
    Items

  }
})
